<template>
  <div>
    <skeleton-loader v-if="loading"></skeleton-loader>
    <div v-else id="user-profile">
      <profile-header :header-data="ngoData" @tabChange="setActiveTab" />
      <section id="profile-info">
        <b-row>
          <b-col lg="9" cols="12" order="1" order-lg="2">
            <profile-post />
          </b-col>
          <b-col lg="3" cols="12" order="2">
            <instructions-card />
            <profile-score-card />
            <b-card class="d-flex flex-col justify-content-center">
              <div class="d-flex align-items-center">
                <h4 class="mb-0">رمز QR الخاص بصفحة المنظمة</h4>

                <b-button
                  @click="downloadQr"
                  variant="flat-success"
                  class="btn-icon rounded-circle mx-50"
                  size="sm"
                >
                  <feather-icon size="18" icon="DownloadIcon" />
                </b-button>
              </div>
              <hr class="my-1" />
              <div class="text-center">
                <qrcode-vue
                  id="qr-code"
                  :value="ngoLink"
                  :size="150"
                  level="H"
                />
                <b-form-group class="my-1 w-75 mx-auto">
                  <b-input-group>
                    <b-form-input dir="ltr" :value="ngoLink" readonly />

                    <!-- button -->
                    <b-input-group-append is-text class="p-0">
                      <b-button
                        v-clipboard:copy="ngoLink"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        variant="white"
                        class="p-0"
                      >
                        <feather-icon
                          icon="CopyIcon"
                          size="18"
                          color="#82868b"
                        />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </section>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BCard,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
} from "bootstrap-vue";
import ProfileHeader from "./components/ProfileHeader.vue";
import InstructionsCard from "@/components/InstructionsCard.vue";
import ProfilePost from "./components/ProfileBody.vue";
import SkeletonLoader from "./components/SkeletonLoader.vue";
import { mapActions, mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ProfileScoreCard from "./components/ProfileScoreCard.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    ProfileHeader,
    InstructionsCard,
    ProfilePost,
    SkeletonLoader,
    QrcodeVue,
    BCard,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    ProfileScoreCard,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters("NgoProfile", ["ngoData", "loading"]),
    ngoLink() {
      return this.$baseUrl + "/ngo/" + this.ngoData.id;
    },
  },

  created() {
    this.fetchUserNotifications();
    this.fetchNgoData();
  },
  methods: {
    ...mapActions("User", ["fetchUserNotifications"]),
    ...mapActions("NgoProfile", ["fetchNgoData"]),
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    onCopy() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "تم نسخ رابط صفحة المنظمة",
          icon: "CopyIcon",
          variant: "success",
        },
      });
    },
    onError() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "حدث خطأ في نسخ الرابط",
          icon: "BellIcon",
        },
      });
    },
    downloadQr() {
      var qrCanvas = document.getElementById("qr-code").children[0];
      var pngCanvas = qrCanvas.toDataURL("img/png");
      const linkSource = pngCanvas;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = "qr-code.png";
      downloadLink.click();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/page-profile.scss";
</style>
